import { Component, OnInit } from '@angular/core';
import { TemplateService } from '../shared/services/template.service';
import { AccessService } from '../core/services/access.service';

export type HeaderType =
  | 'header-default'
  | 'header-primary'
  | 'header-info'
  | 'header-success'
  | 'header-danger'
  | 'header-dark';
export type SideNavType = 'sidenav-default' | 'side-nav-dark';

@Component({
  selector: 'app-dashboard',
  templateUrl: './common-layout.component.html',
})
export class CommonLayoutComponent implements OnInit {
  headerSelected: HeaderType;
  sidenavSelected: SideNavType;
  isCollapse: boolean;

  constructor(
    private tplSvc: TemplateService,
    public accessApi: AccessService,
  ) {}

  ngOnInit() {
    this.tplSvc.isSideNavCollapseChanges.subscribe(
      (isCollapse) => (this.isCollapse = isCollapse),
    );
  }
}
